/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
  GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  GetApiV1CourseregistrationSharedCourseListMultiple401,
  GetApiV1CourseregistrationSharedCourseListMultiple500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedCourseListMultiple.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationSharedCourseListMultiple } from "../../clients/courseRegistrationSharedController/getApiV1CourseregistrationSharedCourseListMultiple.ts";

export const getApiV1CourseregistrationSharedCourseListMultipleQueryKey = (
  params?: GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
) =>
  [
    { url: "/api/v1/courseregistration/shared/course-list-multiple" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1CourseregistrationSharedCourseListMultipleQueryKey =
  ReturnType<typeof getApiV1CourseregistrationSharedCourseListMultipleQueryKey>;

export function getApiV1CourseregistrationSharedCourseListMultipleQueryOptions(
  params?: GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationSharedCourseListMultipleQueryKey(params);
  return queryOptions<
    GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedCourseListMultiple401
      | GetApiV1CourseregistrationSharedCourseListMultiple500
    >,
    GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationSharedCourseListMultiple(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna cursos ativos filtrados por texto, empresa e opcionalmente por polo. A chave retornada tem o prefixo 'GRP' (ex.: 'GRP123'). Usuários com papel Polo recebem apenas cursos vinculados aos seus polos. A empresa do usuário autenticado sobrepõe o parâmetro 'companyId' quando aplicável. Quando 'includeRelationShip' é verdadeiro, inclui cursos associados à empresa via tabela de relacionamento. **(Requer Authorization para autenticação)**
 * @summary Retorna lista de cursos para seleção múltipla (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/course-list-multiple}
 */
export function useGetApiV1CourseregistrationSharedCourseListMultiple<
  TData = GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
  TQueryData = GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationSharedCourseListMultipleQueryKey,
>(
  params?: GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationSharedCourseListMultiple401
          | GetApiV1CourseregistrationSharedCourseListMultiple500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationSharedCourseListMultipleQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1CourseregistrationSharedCourseListMultipleQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedCourseListMultiple401
      | GetApiV1CourseregistrationSharedCourseListMultiple500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
